/*
 Режим шапки/прокрутки lite-таблицы вынесен отдельно, чтобы Analytics.vue,
 превью и сама таблица читали одно и то же значение.

   sticky  шапка остаётся сверху, у таблицы своя прокрутка;
   scroll  шапка уезжает вверх вместе с содержимым (используется сейчас);
   page    у таблицы нет своей прокрутки, она прокручивается вместе со страницей.

 Тоггл переключения режима убран, режим зафиксирован на scroll для всех выборок.
*/

import { ref } from "vue";

export type LiteHeaderMode = "sticky" | "scroll" | "page";

export const liteHeaderModeFlag = ref<LiteHeaderMode>("scroll");
